import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS, CONTENT_MAX_WIDTH, FONT } from "../../shared/styles";
import { REQUIREMENTS } from "./constants";

function CustomDomainRequirements() {
  return (
    <Box
      sx={{
        mt: "16px",
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        minHeight: "168px",
        p: "20px 24px",
        borderRadius: "8px",
        border: `1px solid ${COLORS.border}`,
        bgcolor: COLORS.backgroundLight,
        boxSizing: "border-box",
      }}
    >
      <Typography
        component="p"
        sx={{
          m: 0,
          color: COLORS.textPrimary,
          fontFamily: FONT.family,
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "22px",
        }}
      >
        Requirements
      </Typography>
      <Box
        component="ul"
        sx={{
          m: "8px 0 0",
          pl: "20px",
          color: COLORS.textSecondary,
          fontFamily: FONT.family,
          fontSize: "12px",
          fontWeight: 400,
          lineHeight: "26px",
          "& li": { m: 0 },
        }}
      >
        {REQUIREMENTS.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </Box>
    </Box>
  );
}

export default CustomDomainRequirements;
